import styled from "styled-components"
import StyledButton from "common/views/components/StyledButton"
import React from "react"

const CenteredReferralStatusButton = styled(StyledButton)`
  width: ${props => props.width ? props.width : "300"}px;
  margin: 24px auto 0 auto !important;
`

export const SaveButton = ({ onSave, disabled }) => {
  return (
    <CenteredReferralStatusButton positive oldColorPalette={true} borderRadius="6px" paddingTopBottom="10" width="215" disabled={disabled} onClick={onSave}>Save Changes</CenteredReferralStatusButton>
  )
}

export const AddButton = ({ onClick, children }) => {
  return (
    <CenteredReferralStatusButton primary oldColorPalette={true} borderRadius="6px" paddingTopBottom="10" width="300" onClick={onClick}>{ children }</CenteredReferralStatusButton>
  )
}
